import { render, staticRenderFns } from "./itemsCollectionCustomField.vue?vue&type=template&id=9be04610&"
import script from "./itemsCollectionCustomField.vue?vue&type=script&lang=js&"
export * from "./itemsCollectionCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports